const routes = [
    {
        name: 'listarPix',
        path: '/banco_inter/pix',
        alias: '/banco_inter/pix/index',
        component: () => import('../views/Listar')
    },
    {
        path: '/banco_inter/pix/visualizar/:integracao/:id',
        component: () => import('../views/Visualizar')
    },
    {
        name: 'receberPix',
        path: '/banco_inter/pix/receber',
        component: () => import('../views/Receber')
    },
]

export default routes
